import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import InfoUnavailable from '../../../../components/common/InfoUnavailable';

const LabelWarningInfo = forwardRef(function ({ labelWarnings }, ref) {
  const isSpecialCharacterOnly = (text) => /^[^a-zA-Z0-9]+$/.test(text);

  return (
    <div ref={ref} className="mb-36 scroll-offset" id='label-warning-info-section'>
      <h4 className="accordion-header">Label Warnings</h4>
      <div className="accordion-body">
        {labelWarnings?.Label_warnings?.length ? (
          <div>
            <ul className="indicator">
              {labelWarnings.Label_warnings.filter(
                (labelWarning) =>
                  !isSpecialCharacterOnly(labelWarning.LabelWarningText),
              ).map((labelWarning, index) => (
                <li key={`label-warning-${index}`}>
                  <span>{labelWarning.LabelWarningText}</span>
                  <button type="button" disabled className="btn border-0">
                    Priority {labelWarning.Priority}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <InfoUnavailable />
        )}
      </div>
    </div>
  );
});

LabelWarningInfo.propTypes = {
  labelWarnings: PropTypes.object.isRequired,
};

LabelWarningInfo.displayName = 'LabelWarningInfo';

export default LabelWarningInfo;
